import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Image, { ImageDataType } from '../Image';
import Card from '../Card';
import { discountTypeMap } from '../../utility/useCourseDataHelper';
import { getBundleCheckoutRoute } from '../../utility/stringHelper';

import './BundleCard.scss';

const className = 'c-BundleCard';

const BundleCard = ({
  cardImgData,
  discountValue,
  discountType,
  slug,
  maxAllowedCourses,
}) => {
  const checkoutRoute = getBundleCheckoutRoute({ bundleSlug: slug });

  return (
    <div className={className}>
      <Link title="Bundle Page" to={checkoutRoute}>
        <Card>
          <div className={`${className}__img-wrapper`}>
            <Image {...cardImgData} />
          </div>

          <div className={`${className}__detail__wrapper`}>
            <div className={`${className}__price`}>
              {discountValue}
              {discountTypeMap[discountType]} Off
            </div>
            <div className={`${className}__price__description`}>
              when you buy {maxAllowedCourses} courses
            </div>
          </div>
        </Card>
      </Link>
    </div>
  );
};

export const BundleCardDataType = PropTypes.shape({
  cardImgData: PropTypes.shape(ImageDataType),
  maxAllowedCourses: PropTypes.number.isRequired,
  discountValue: PropTypes.number.isRequired,
  discountType: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
});

BundleCard.propTypes = {
  cardImgData: PropTypes.shape(ImageDataType),
  maxAllowedCourses: PropTypes.number.isRequired,
  discountValue: PropTypes.number.isRequired,
  discountType: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

export default BundleCard;
